import React, { useEffect, useState } from "react";
import {
    Box,
    Grid,
    Typography,
    Paper,
    IconButton,
    Tooltip,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import { useForm } from "react-hook-form";

import WSTextField, { TextType } from "../../../Components/TextBox/WSTextBox";
import { callAPI, Method } from "../../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ConfirmationPopup from "../../../Components/Confirmation/Confirmation";

const Bank = () => {
    const [loading, setLoading] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [selectedId, setSelectedId] = useState<string | number>(0);
    const [isPopupOpen, setPopupOpen] = useState(false);
    const { showMessage } = useSnackbar();
    const params = useParams();
    const id = params.id;
    const navigate = useNavigate();


    const location = useLocation();
const from = location.state?.from;

    const {
        control,
        handleSubmit,
        reset,
        formState: { isValid },
    } = useForm({
        mode: "onChange",
        defaultValues: {
            BankName: "",
            Branch: "",
            AccountNumber: "",
            IFSC: ""
        },
    });

    useEffect(() => {
        console.log("🔍 Raw params:", params);
        console.log("🔍 ID from params:", id, "Type:", typeof id);

        if (!id || id === "undefined" || id === "null" || id.trim() === "") {
            console.log("➕ CREATE MODE - No valid ID found");
            setIsEditMode(false);
            reset();
            return;
        }

        console.log("✏️ EDIT MODE - Loading warehouse:", id);
        setIsEditMode(true);
        fetchbankData(id);
    }, [id, showMessage, reset]);


    const fetchbankData = async (bankId: string) => {
        try {
            setLoading(true);
            console.log("📡 Fetching unit:", bankId);

            const response = await callAPI(`banks/${bankId}`, Method.GET);
            console.log("📦 API Response:", response);

            if (response?.success && response.data) {
                const bankData = response.data;
                console.log("✅ Loading data:", bankData);

                reset({
                    BankName: bankData.BankName || "",
                    Branch: bankData.Branch || "",
                    AccountNumber: bankData.AccountNumber || "",
                    IFSC: bankData.IFSC || "",

                });
            } else {
                console.error("❌ No data in response:", response);
                showMessage(response?.message || `bank ${bankId} not found`, "error");
                setIsEditMode(false);
            }
        } catch (error: any) {
            console.error("❌ Fetch error:", error.response?.data || error.message);
            showMessage("Failed to load bank data", "error");
            setIsEditMode(false);
        } finally {
            setLoading(false);
        }
    };

    const onSubmit = async (data: any) => {
        try {
            setLoading(true);
            const requestBody = {
                BankName: data.BankName?.trim(),
                Branch: data.Branch || "",
                AccountNumber: data.AccountNumber || "",
                IFSC: data.IFSC || "",

            };

            console.log("📤", isEditMode ? "UPDATE" : "CREATE", requestBody);

            let response;
            if (isEditMode && id) {
                response = await callAPI(`banks/${id}`, Method.PUT, requestBody);
            } else {
                response = await callAPI("banks/create", Method.POST, requestBody);
            }

            if (response?.success) {
                showMessage(
                    isEditMode
                        ? "bank updated successfully!"
                        : "bank created successfully!",
                    "success"
                );
                // navigate("/bank/list");

            if (response?.success) {
  if (from === "chequeentry") {
    navigate("/chequeentry");
  }
  
   else {
    navigate("/bank/list");
  }
}

            } else {
                showMessage(response?.message || "Operation failed", "error");
            }
        } catch (error: any) {
            console.error("❌ Submit error:", error);
            showMessage(error?.message || "Operation failed", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteClick = () => {
        if (!id) return;
        setSelectedId(id);
        setPopupOpen(true);
    };


    return (
        <Box sx={{ p: 2, background: "#f0f0f0", minHeight: "100vh" }}>

            { }
            <Box display="flex" justifyContent="space-between" mb={4}>
                <Typography sx={{ fontSize: "20px", fontWeight: 600 }}>
                    {isEditMode ? "Edit Bank Details" : "Bank Details"}
                </Typography>

                <Box>

                    {isEditMode && (
                        <IconButton
                            sx={{ background: "black", color: "#fff" }}
                            onClick={handleDeleteClick}
                            disabled={loading}
                        >
                            <DeleteIcon fontSize="small" />
                        </IconButton>
                    )}
                </Box>
            </Box>

            { }
            <Paper
                sx={{
                    borderRadius: "16px",
                    p: 3,
                    background: "#fafafa",
                }}
            >
                { }
                <Box display="flex" justifyContent="space-between" mb={3}>
                    <Typography sx={{ fontSize: "18px", fontWeight: 500 }}>
                        {/* {isEditMode ? " Edit Bank Details" : "Bank Details"} */}
                    </Typography>

                     <Tooltip title={isEditMode ? "Update Bank" : "Create Bank"} arrow>
                                <IconButton
                                  sx={{ background: "#000", color: "#fff" }}
                                  onClick={handleSubmit(onSubmit)}
                                  disabled={!isValid || loading}
                                >
                                  <SaveIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                </Box>


                <Grid container rowSpacing={8} columnSpacing={5}>



                    <Grid item xs={6}>
                        <WSTextField
                            name="BankName"
                            label="Bankname"
                            id="BankName"
                            control={control}

                        />
                    </Grid>
                    <Grid item xs={6}>
                        <WSTextField
                            name="Branch"
                            label="Branch"
                            id="Branch" control={control}

                        />
                    </Grid>

                    <Grid item xs={6}>
                        <WSTextField
                            name="AccountNumber"
                            label="Account Number"
                            id="AccountNumber"
                            control={control}
                            type={TextType.AllowOnlyNumber}

                        />
                    </Grid>

                    <Grid item xs={6}>
                        <WSTextField
                            name="IFSC"
                            label="IFSC Code"
                            id="IFSC"
                            control={control}


                        />
                    </Grid>





                </Grid>
            </Paper>

            <ConfirmationPopup
                type="DELETE"
                apiUrl="banks"
                id={selectedId}
                confirmMessage="Are you sure you want to delete this bank?"
                open={isPopupOpen}
                onClose={() => setPopupOpen(false)}
                onConfirm={async (data) => {
                    console.log("delete data", data)
                    if (!selectedId) return;

                    if (data?.success === true) {

                        showMessage(data?.message, "success");
                        navigate("/bank/list");
                    } else {
                        showMessage(data?.detail, "error");
                    }

                    setPopupOpen(false);
                }}
            />
        </Box>
    );
};

export default Bank;

